#import "../fragments/context-document-fragment.graphql"

mutation RecrawlContextDocuments($input: ContextDocumentRecrawlInput!) {
    contextDocumentRecrawl(input: $input) {
        ...ContextDocumentFragment
    }
}
